/**
 * Copyright 2013-present, Novivia, Inc.
 * All rights reserved.
 */

/* eslint-disable filenames/match-regex */

/**
 * A module encoding/decoding UUIDv4 id to base62
 * @module utilities/formats/shortUUID
 */
"use strict";

var _ = require("lodash");
var deprecate = require("depd")("@auex/utilities");
var uuidBase62 = require("uuid-base62");

var FunctionCallError = require("../errors").FunctionCallError;
var MissingParameterError = FunctionCallError.MissingParameterError;

/**
 * Encode a UUID to base62.
 * @param  {string}  uuid   Raw UUIDv4 string.
 * @return {string}         UUIDv4 encoded in base62.
 */
function encode(uuid) {
  if (!_.isString(uuid)) {
    throw new MissingParameterError(null, "Missing UUIDv4 to encode.", "uuidv4");
  }

  return uuidBase62.encode(uuid);
}

/**
 * Decode a base62 id to the orginial UUIDv4.
 * @param  {string}  uuid   Base62 encoded UUIDv4 string.
 * @return {string}         Decoded string.
 */
function decode(uuid) {
  if (!_.isString(uuid)) {
    throw new MissingParameterError(null, "Missing base 62 UUIDv4 to decode.", "base62-uuidv4");
  }

  try {
    return uuidBase62.decode(uuid);
  } catch (err) {
    return uuid;
  }
}

module.exports = exports = {
  decode: deprecate.function(decode, "'decode' is deprecated in this module. Please use" + " '@novivia/utilities/formats/uuid'.decode instead."),
  encode: deprecate.function(encode, "'encode' is deprecated in this module. Please use" + " '@novivia/utilities/formats/uuid'.encode instead.")
};


//////////////////
// WEBPACK FOOTER
// /private/var/folders/n9/yczdnstj3wdc9q5tzm6d45c00000gp/T/maison-encans-auex-website/~/@auex/utilities/lib/formats/shortUUID.js
// module id = 873
// module chunks = 6